import { arrayOf, bool, instanceOf, shape, string } from 'prop-types';

const glossaryContent = arrayOf(
  shape({
    name: string,
    slug: string,
    topics: arrayOf(
      shape({
        name: string,
        slug: string,
        content: string,
      })
    ),
  })
);

export default shape({
  loading: bool.isRequired,
  success: bool.isRequired,
  error: instanceOf(Error),
  errorInfo: string,
  data: glossaryContent,
});
